import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Dialog from '@material-ui/core/Dialog';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import MaryMagicSurvey from './connected';
import { colors } from '../../constants/colors';

const SmoothDialog = styled(Dialog)`
  -webkit-font-smoothing: antialiased;
  & .dialog-root {
    background-color: ${colors.whiteGrey};
  }
`;

const Close = styled.div`
  width: 25px;
  height: 25px;
  position: absolute;
  right: 26px;
  top: 20px;
  cursor: pointer;

  &:before {
    content: '';
    left: 50%;
    height: 100%;
    width: 1px;
    position: absolute;
    transform: rotate(45deg);
    background-color: ${colors.theWhiteAlbum};
  }

  &:after {
    content: '';
    left: 50%;
    height: 100%;
    width: 1px;
    position: absolute;
    transform: rotate(-45deg);
    background-color: ${colors.theWhiteAlbum};
  }
`;

class MaryMagicSurveyModal extends PureComponent {
  static propTypes = {
    open: PropTypes.bool,
    fullScreen: PropTypes.bool,
    onClose: PropTypes.func,
  };

  render() {
    const { open, fullScreen, onClose } = this.props;

    return (
      <SmoothDialog
        open={open}
        onClose={onClose}
        fullScreen={fullScreen}
        maxWidth="sm"
        scroll="body"
        PaperProps={{ classes: { root: 'dialog-root' } }}
        fullWidth
      >
        <Close onClick={onClose} />
        <MaryMagicSurvey />
      </SmoothDialog>
    );
  }
}

export default withMobileDialog({ breakpoint: 'xs' })(MaryMagicSurveyModal);
